// YouTube videos embedded on matching pages (PageVideo in the default layout), with VideoObject schema.
// Workspace369 channel only: never embed Client Work HQ videos here, nor their VideoObject (Szymon, 2026-09-29; wiki rules.md).
// Source: public watch-page metadata, fetched 2026-10-12. Keep one video per page; paths are unlocalized, no trailing slash.

export interface PageVideo {
  id: string;
  title: string;
  description: string;
  uploadDate: string;
  duration: string;
  channel: string;
}

const videos: Record<string, PageVideo> = {
  "wQOtKZMauys": { id: "wQOtKZMauys", title: "Automatic payment reminders in Workspace369", description: "How to set up automatic payment reminders in Workspace369: start from the Escalating unpaid invoice reminders template in Workflows, check the trigger and the emails it sends, see how the reminders stop once an invoice is paid, adjust the waits between reminders, and turn it on.", uploadDate: "2026-10-09T13:07:53-07:00", duration: 'PT1M29S', channel: "Workspace369" },
  "SkJNefM03Ik": { id: "SkJNefM03Ik", title: "Workspace369 invoices, step by step", description: "How to create and manage invoices in Workspace369, step by step: build an invoice from your catalog, set its dates and tax, split it into a payment plan with installments, set up a repeat invoice, send it by email or text, record a payment as it comes in, and track what's still due.", uploadDate: "2026-10-09T10:58:38-07:00", duration: 'PT2M20S', channel: "Workspace369" },
  "nmkYDNUB4iw": { id: "nmkYDNUB4iw", title: "Workspace369 proposals, step by step", description: "How to build a proposal in Workspace369, step by step: choose a theme and cover, add sections and timelines, and preview what your client sees.", uploadDate: "2026-10-08T13:19:25-07:00", duration: 'PT2M48S', channel: "Workspace369" },
};

export const pageVideos: Record<string, PageVideo> = {
  '/solutions/proposal-tracking-software': videos["nmkYDNUB4iw"],
  '/tools/payment-reminder-generator': videos["wQOtKZMauys"],
  '/tools/invoice-generator': videos["SkJNefM03Ik"],
  '/solutions/proposal-software-for-consultants': videos["nmkYDNUB4iw"],
};
